/* unplugin-vue-components disabled */import script from "./MobileSignInButton.vue?vue&type=script&setup=true&lang=js"
export * from "./MobileSignInButton.vue?vue&type=script&setup=true&lang=js"

import "./MobileSignInButton.vue?vue&type=style&index=0&id=08c93cba&lang=scss"

const __exports__ = script;

export default __exports__